import React, { useRef, useEffect } from "react";
import { Menubar } from "primereact/menubar";
import { Menu } from "primereact/menu";
import useLogout from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import { Chip } from "primereact/chip";
import { Dropdown } from "primereact/dropdown";
import ThemeSwitcher from "./ThemeSwitcher";

export default function Navbar({Auth, selectedNomina, setSelectedNomina }) {
  const navigate = useNavigate();

  const tieneRol = (rolBuscado) => Auth.roles.includes(rolBuscado);

  const itemsBase = [
    {
      label: "Inicio",
      icon: "pi pi-home",
      url: "/",
    },
  ];
   let items = [...itemsBase];

  // if (tieneRol(5150)) {
    items.push({
      label: "Catalogos",
      icon: "pi pi-book",
      //url: "/admin",
      items: [
        { label: "Alumnos", icon: "pi pi-users", url: "/alumnos/listado" },
        { label: "Conceptos", icon: "pi pi-bookmark", url: "/conceptos" },
      ],
    });

    items.push({
      label: "Cobranza",
      icon: "pi pi-dollar",
      //url: "/admin",
      items: [
        { label: "Cargos", icon: "pi pi-wallet", url: "/cargos" },
        //{ label: "Conceptos", icon: "pi pi-bookmark", url: "/conceptos" },
        { label: "Pagos", icon: "pi pi-money-bill", url: "/pagos" },
        { label: "Estado de Cuenta", icon: "pi pi-file", url: "/estado-cuenta" },
        { label: "Facturas", icon: "pi pi-file-pdf", url: "/facturacion" },
      ],
    });

    items.push({
      label: "Inventario",
      icon: "pi pi-box",
      url: "/inventario",
      // items: [
      //   { label: "Cargos", icon: "pi pi-wallet", url: "/cargos" },
      //   { label: "Conceptos", icon: "pi pi-bookmark", url: "/conceptos" },
      //   { label: "Pagos", icon: "pi pi-money-bill", url: "/pagos" },
      //   { label: "Estado de Cuenta", icon: "pi pi-file", url: "/estado-cuenta" },
      // ],
    });
  // }
  //  if (tieneRol(1984)) {
  //   items.push({
  //     label: "Editor",
  //     icon: "pi pi-pencil",
  //     url: "/editor",
  //     // items: [
  //     //   { label: "Editar contenido", icon: "pi pi-edit", url: "/editor/editar" },
  //     //   { label: "Mis documentos", icon: "pi pi-file", url: "/editor/documentos" },
  //     // ],
  //   });
  // }
  const menuRight = useRef(null);
  const toast = useRef(null);
  const logout = useLogout();
  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  const optionsUser = [
    {
      label: "Opciones",
      items: [
        {
          label: "Editar",
          icon: "pi pi-user-edit",
           command: () => navigate('/perfil'),
        },
        {
          label: "Salir",
          icon: "pi pi-sign-out",
          command: () => {
            signOut();
          },
        },
      ],
    },
  ];
  const start = (
    <img
      alt="logo"
      src="/logo.png"
      height="50"
      className="mr-2"
    ></img>
  );
  const content = (
    <>
      <span className="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">
        {Auth.nombre?.charAt(0).toUpperCase()}
      </span>
      <span className="ml-2 font-medium">{Auth.nombre}</span>
    </>
  );
  const [nominas, setNominas] = React.useState([]);  
  useEffect(() => {

    //console.log("Auth:", Auth);
    setNominas(Auth.Parametros.Nominas);
    const defaultNomina = Auth.Parametros.Nominas.find(
      (n) => n.numero === Auth.Parametros.Nominas[0].numero
    );
    setSelectedNomina(defaultNomina);
  }, []);

  useEffect(() => {
   // console.log("idNomina actualizado:", selectedNomina);
  }, [selectedNomina]);

  if (!Auth || !Auth.nombre || !Auth.Parametros?.Nominas) {
    return (
      <div className="bg-yellow-600 text-white p-4">
        ⚠️ Cargando Navbar... Datos incompletos
      </div>
    );
  }

  const end = (
    <>
      <Menu
        model={optionsUser}
        popup
        ref={menuRight}
        id="popup_menu_right"
        popupAlignment="right"
      />
      <div className="flex align-items-center gap-2">
      {selectedNomina && (
  <>
    {/* Periodo: {selectedNomina.PeriodoActual} del {selectedNomina.FechaInicial} al {selectedNomina.FechaFinal} */}
  </>
)}
        {/* <Dropdown
          //value={idNomina}
          value={selectedNomina}
          options={nominas}
          //onChange={(e) => setIdNomina(e.value)}
          onChange={(e) => setSelectedNomina(e.value)}
          optionLabel="Nomina"
          placeholder="Seleccione la nomina"
          filter
          // showClear
          filterBy="Nomina"
          className="selEmpleado"
        /> */}
        <ThemeSwitcher/>
        <div
          className="drop align-items-center"
          onClick={(event) => menuRight.current.toggle(event)}
        >
          <Chip className="nombre pl-0 pr-3" template={content} />
        </div>
      </div>
    </>
  );

  return (
    <>
    <div className="card">
      <Menubar model={items} start={start} end={end} />
    </div>
    </>
  );
}
